import forge from "node-forge";
import { v4 } from "uuid";

let key = decodeURIComponent(process.env.REACT_APP_ENCRYPTION_KEY!);

export function generateUUID(length = 36) {
  const uuidV = v4().slice(0, length);
  return uuidV;
}

export function encrypt(text: string): string {
  let iv = generateUUID(16);
  let cipher = forge.cipher.createCipher("AES-CBC", key);
  cipher.start({ iv: iv });
  const utf8Bytes = forge.util.encodeUtf8(text);
  cipher.update(forge.util.createBuffer(utf8Bytes));
  cipher.finish();
  let encrypted = cipher.output;
  let d = forge.util.encode64(encrypted.data);
  return `${d}|${iv}`;
}

export function decrypt(encryptedText: string): any {
  const splittedText = encryptedText?.split("|");
  const [encData, iv] = [splittedText?.[0], splittedText?.[1]];
  let decipher = forge.cipher.createDecipher("AES-CBC", key);
  decipher.start({ iv: iv });
  decipher.update(forge.util.createBuffer(forge.util.decode64(encData)));
  let result = decipher.finish();
  if (result) {
    return forge.util.decodeUtf8(decipher.output.getBytes());
  } else {
    throw new Error("Could not decrypt");
  }
}
